/**
 * Constants and other gloabl settings
 */

export const STORAGE_KEY: string = "da-sec-info:checklist";
